<template>

	<div class="panel panel-clinic">

		<div class="panel-heading collapsed" href="#form_booking" data-toggle="collapse">

			<div class="arrow-down"></div>

			<h2 class="panel-title">Klippkort</h2>

		</div>

		<div id="form_booking" class="panel-collapse collapse">

			<div class="panel-body">

				<h3>Publicerad i klippkort</h3>
                <p><i>Det kan ta upp till 15 minuter innan partnern visas i klippkortet.</i></p>
				<div class="form-horizontal">
					<div class="form-group oddevencol">
						<label for="name_clinic" class="col-md-14 control-label">Publicerad i klippkort</label>
						<div class="col-md-36">
							<input type="checkbox" v-model="clinic.is_public" :true-value="1" :false-value="0">
						</div>
					</div>
				</div>

				<p class="comment">Uppgifter om bokning (fylls i först i samband med anslutning)</p><br>

				<h3>Partnern erbjuder följande av våra tjänster</h3>

				<div class="form-horizontal">

                  <div v-if="clinic.product_area_ids.indexOf(1) !== -1">
                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :showComment="true"
                        type="checkbox_25min"
                        layout="checkBox"
                        title="25 min">
                    </row-meta>
                    <row-text :model.sync="clinic.booking_link" text="Bokningslänk 25 min" :asterisk="true"></row-text>
                    <div style="width:100%; height: 30px;"></div>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :showComment="true"
                        type="checkbox_40min"
                        layout="checkBox"
                        title="40 min">
                    </row-meta>
                    <row-text :model.sync="clinic.booking_link_2" text="Bokningslänk 40 min" :asterisk="true"></row-text>
                    <div style="width:100%; height: 30px;"></div>

                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :showComment="true"
                        type="checkbox_50min"
                        layout="checkBox"
                        title="50 min">
                    </row-meta>
                    <row-text :model.sync="clinic.booking_link_3" text="Bokningslänk 50 min" :asterisk="true"></row-text>
                    <div style="width:100%; height: 30px;"></div>
                  </div>

                  <div v-if="clinic.product_area_ids.indexOf(2) !== -1">
                    <row-meta
                        :clinic-id="clinic.id"
                        :row-meta="meta"
                        :showComment="true"
                        type="checkbox_60min"
                        layout="checkBox"
                        title="60 min">
                    </row-meta>
                    <row-text :model.sync="clinic.booking_link_60" text="Bokningslänk 60 min" :asterisk="true"></row-text>
                    <div style="width:100%; height: 30px;"></div>
                  </div>

				</div>

                <h3>Bokningssystem</h3>
                <div class="form-horizontal">

                    <div class="row row-meta oddevencol">
                        <div class="col-md-14 control-label first">
                            <label>Bokningssystem</label>
                        </div>
                        <div class="second col-md-26">
                            <div>
                                {{ meta.select_booking_system.value }}
                            </div>
                        </div>
                    </div>

                    <div class="row row-meta oddevencol">
                        <div class="col-md-14 control-label first">
                            <label>ID i bokningssystem</label>
                        </div>
                        <div class="second col-md-26">
                            <div>
                                {{ meta.text_booking_id.value }}
                            </div>
                        </div>
                    </div>
                </div>

				<h3>Information/instruktioner</h3>

				<div class="form-horizontal">
					<row-text :model.sync="clinic.card_name_person" text="Partners namn" :asterisk="true"></row-text>
					<row-text :model.sync="clinic.card_name_clinic" text="Mottagningsnamn" :asterisk="true"></row-text>
				</div>

				<p class="comment subline">Båda fälten kan användas flexibelt för att ange information. Rubrik visas endast om innehåll finns.</p>

				<div class="form-horizontal">

					<row-text
						:model.sync="clinic.booking_info"
						type="textarea"
						text="Information om bokning (visas i klippkort)"
						comment="Denna ruta används främst när massören har manuellt bokningssystem och någon information utöver bokningsknapparna behövs."
						:asterisk="true">
					</row-text>

					<row-text
						:model.sync="clinic.booking_instructions"
						type="textarea"
						text="Övrig information (visas i klippkort)"
						comment="Denna ruta används för särskild information.<br><br>Exempel: Byte av mottagningsadress, sjukskrivning, avslut. Massören finns bokningsbar till X/X-XXXX."
						:asterisk="true">
					</row-text>

					<row-text
						:model.sync="clinic.booking_directions"
						type="textarea"
						text="Hitta hit (visas i klippkort)"
						comment=""
						:asterisk="true">
					</row-text>

				</div>

        <h3>Visa bokningsknappar</h3>

        <div class="form-horizontal">
          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            :showComment="true"
            type="checkbox_show_booking_button_sms"
            layout="checkBox"
            title="SMS-bokning">
          </row-meta>
          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            :showComment="true"
            type="checkbox_show_booking_button_phone"
            layout="checkBox"
            title="Telefonbokning">
          </row-meta>
          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            :showComment="true"
            type="checkbox_show_booking_button_email"
            layout="checkBox"
            title="E-postbokning">
          </row-meta>
        </div>

                <!--
				<h3>Bokningslänkar</h3>
				<p class="comment subline">
					En bokningslänk länkar direkt till aktuell tjänst, eller till en startsida för nätbaserad bokning hos massören.
					<br>
					En länktext är den text som visas på aktuell knapp i klippkortet, t ex "25 min"
					<br>
					Alla länkar/länktexter behöver inte fyllas i. Endast de som är ifyllda visas i kortet.
				</p>

				<div class="form-horizontal">

					<row-text :model.sync="clinic.booking_link" text="Bokningslänk" :asterisk="true"></row-text>
					<row-text :model.sync="clinic.booking_link_text" text="Länktext" :asterisk="true"></row-text>

					<row-text :model.sync="clinic.booking_link_2" text="Bokningslänk 2" :asterisk="true"></row-text>
					<row-text :model.sync="clinic.booking_link_text_2" text="Länktext 2" :asterisk="true"></row-text>

					<row-text :model.sync="clinic.booking_link_3" text="Bokningslänk 3" :asterisk="true"></row-text>
					<row-text :model.sync="clinic.booking_link_text_3" text="Länktext 3" :asterisk="true"></row-text>

				</div>
				-->

				<h3>Öppettider</h3>

				<div class="form-horizontal">

					<row-text
						:model.sync="clinic.hours_weekdays"
						type="textarea"
						text="Öppettider"
						:asterisk="true">
					</row-text>

					<row-text
						:model.sync="clinic.public_phone"
						text="Mobilnummer eller telefonnummer som visas för kund"
						:asterisk="true">
					</row-text>

					<row-text
						:model.sync="clinic.public_email"
						text="E-post som visas för kund"
						:asterisk="true">
					</row-text>

				</div>

        <h3>Visa betyg i klippkort</h3>
        <div class="form-horizontal">
          <div class="form-group oddevencol">
            <label for="name_clinic" class="col-md-14 control-label">Visa betyg i klippkort</label>
            <div class="col-md-36">
              <input type="checkbox" v-model="clinic.show_survey_score">
            </div>
          </div>
        </div>

        <h3>Mottagning med anställda</h3>
        <div class="form-horizontal">
          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            :showComment="true"
            type="checkbox_multiple_clinics"
            layout="checkBox"
            title="Mottagning med anställda">
          </row-meta>
        </div>

			</div>

		</div>

	</div>

</template>

<script>

import mixin from './mixin'
import axios from 'axios'

export default {

    mixins: [mixin],

    data () {
        return {

        }
    }
}

</script>
